/* DOORS CRM intent events. Catalog-only payloads; Google & YouTube owns core ecommerce. */
(function (root) {
  'use strict';
  function clean(value) { return String(value == null ? '' : value).replace(/[\u0000-\u001f]/g, ' ').replace(/\s+/g, ' ').trim().replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[redacted]').slice(0, 100); }
  function numericId(value) { var m = String(value || '').match(/(?:^|\/)(\d+)$/); return m ? m[1] : ''; }
  function validPending(value, now) { return value && ['login','sign_up','newsletter_signup'].indexOf(value.kind) >= 0 && typeof value.nonce === 'string' && Number.isFinite(value.at) && now - value.at >= 0 && now - value.at < 30 * 60000; }
  function itemFromSwym(data, catalog, country) {
    var productId = numericId(data && data.empi), variantId = numericId(data && data.epi);
    if (!productId || !variantId) return null;
    var product = (catalog || []).find(function (p) { return String(p.id) === productId; });
    var variant = product && (product.variants || []).find(function (v) { return String(v.id) === variantId; });
    var price = variant ? Number(variant.price) : Number(data.pr);
    var name = clean(product && product.title || data.dt);
    if (!name || !Number.isFinite(price) || price < 0) return null;
    var item = { item_id: 'shopify_' + (country || 'US') + '_' + productId + '_' + variantId,
      item_name: name, price: Math.round(price * 100) / 100, quantity: 1 };
    if (product) { item.item_brand = clean(product.vendor); item.item_category = clean(product.type); }
    if (variant && !/^default title$/i.test(variant.title || '')) item.item_variant = clean(variant.title);
    return item;
  }
  if (typeof module === 'object' && module.exports) { module.exports = { clean: clean, numericId: numericId, validPending: validPending, itemFromSwym: itemFromSwym }; return; }
  var doc = root && root.document, node = doc && doc.getElementById('doors-crm-config'), cfg, common;
  if (!node || root.__doorsCrmAnalytics) return;
  try { cfg = JSON.parse(node.textContent); common = JSON.parse(doc.getElementById('doors-ecommerce-config').textContent); } catch (error) { return; }
  if (['161724072187','162093793531','156196569339'].indexOf(common.theme_id) < 0) return;
  root.__doorsCrmAnalytics = true;
  var AUTH = 'doors_crm_auth_v1', NEWS = 'doors_crm_news_v1';
  function read(key) { try { return JSON.parse(root.sessionStorage.getItem(key)); } catch (error) { return null; } }
  function remove(key) { try { root.sessionStorage.removeItem(key); } catch (error) {} }
  function put(key, value) { try { root.sessionStorage.setItem(key, JSON.stringify(value)); } catch (error) {} }
  var pendingAuth = read(AUTH), pendingNews = read(NEWS);
  var debug = new URL(root.location.href).searchParams.get('qa_crm_analytics') === '1' || !!(pendingAuth && pendingAuth.qa || pendingNews && pendingNews.qa);
  var logs = [], sequence = 0, queue = [], ready = false, probing = false, swym = null, timer, attempts = 0;
  var formLocations = {}, formsSeen = new Set(), wishlistChanges = new Map(), lastWishlistClick = null;
  var wishlistMembership = new Set(), wishlistTouched = new Set(), wishlistMembershipReady = false, membershipLoading = false;
  var viewNodes = new WeakSet(), fetchingViews = new WeakSet();
  function privacyState() { try { var api = root.Shopify && root.Shopify.customerPrivacy; return api && typeof api.analyticsProcessingAllowed === 'function' ? !!api.analyticsProcessingAllowed() : null; } catch (error) { return null; } }
  function allowed() { return privacyState() === true; }
  function trace(stage, data) {
    if (!debug) return; logs.push({ stage: stage, data: data }); if (logs.length > 100) logs.shift();
    var panel = doc.getElementById('doors-crm-debug');
    if (!panel && doc.body) {
      panel = doc.createElement('details'); panel.id = 'doors-crm-debug';
      panel.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:2147483000;background:white;color:black;border:1px solid #777;padding:10px;max-width:600px;max-height:50vh;overflow:auto;font:12px/1.4 monospace';
      var summary = doc.createElement('summary'); summary.textContent = 'CRM analytics — QA'; panel.appendChild(summary);
      var pre = doc.createElement('pre'); pre.style.whiteSpace = 'pre-wrap'; pre.setAttribute('aria-label','CRM analytics QA log'); panel.appendChild(pre); doc.body.appendChild(panel);
    }
    if (panel) panel.querySelector('pre').textContent = JSON.stringify(logs, null, 2);
  }
  function flush() {
    if (!ready || !allowed() || typeof root.gtag !== 'function') return;
    while (queue.length) {
      var e = queue.shift(), params = Object.assign({}, common.context, e.params, { send_to: common.measurement_id,
        event_id: e.id, event_source: 'doors_crm', theme_id: common.theme_id,
        page_location: root.location.origin + root.location.pathname });
      if (debug) { params.debug_mode = true; params.qa_test = 'crm_events_20261103'; }
      root.gtag('event', e.name, params); trace('google_tag_queued', { event_name: e.name, event_id: e.id });
    }
  }
  function probe() {
    if (!allowed() || typeof root.gtag !== 'function') return;
    if (ready) { flush(); return; } if (probing) return; probing = true;
    root.gtag('get', common.measurement_id, 'client_id', function (id) { probing = false; if (!id || !allowed()) return; ready = true; trace('native_google_tag_ready', {}); flush(); });
    root.setTimeout(function () { probing = false; }, 3000);
  }
  function send(name, params) {
    if (!allowed()) { queue = []; trace('consent_blocked', { event_name: name }); return; }
    var id = 'doors_crm_' + Date.now() + '_' + (++sequence), data = Object.assign({}, common.context, params, { event_name: name, event_id: id, theme_id: common.theme_id });
    trace('captured', data);
    try { var api = root.Shopify && root.Shopify.analytics; if (api && typeof api.publish === 'function') Promise.resolve(api.publish('doors:' + name, data)).catch(function () {}); } catch (error) {}
    if (queue.length >= 80) queue.shift(); queue.push({ name: name, params: params, id: id }); probe();
  }
  function newsletterLocation(form) {
    if (form && form.closest('.js-newsletter-popup,.newsletter-popup,[role="dialog"]')) return 'popup';
    if (form && form.closest('footer,.footer, [id^="shopify-section-footer"]')) return 'footer';
    return 'newsletter_section';
  }
  function formType(form) { var field = form.querySelector('input[name="form_type"]'); return field && field.value; }
  function pending(kind, location) { return { kind: kind, at: Date.now(), nonce: Date.now() + '_' + Math.random().toString(36).slice(2), location: location || '', qa: debug }; }
  doc.addEventListener('submit', function (event) {
    var form = event.target; if (!form || form.tagName !== 'FORM') return;
    var kind = formType(form);
    if (kind === 'customer_login' || kind === 'create_customer') {
      if (!cfg.logged_in && allowed()) { put(AUTH, pending(kind === 'customer_login' ? 'login' : 'sign_up')); trace('auth_attempt_pending', { event_name: kind === 'customer_login' ? 'login' : 'sign_up' }); }
      else remove(AUTH);
    } else if (kind === 'customer' && form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) {
      if (allowed()) put(NEWS, pending('newsletter_signup', newsletterLocation(form))); else remove(NEWS);
    }
  }, true);
  function completeForms() {
    if (privacyState() === null) return;
    var auth = read(AUTH), news = read(NEWS);
    if (auth && (!validPending(auth, Date.now()) || !allowed() || doc.querySelector('[data-doors-auth-error]'))) { remove(AUTH); auth = null; }
    if (auth && cfg.logged_in) { remove(AUTH); send(auth.kind, { method: 'email' }); }
    if (news && (!validPending(news, Date.now()) || !allowed())) { remove(NEWS); news = null; }
    if (news) {
      var marker = Array.from(doc.querySelectorAll('[data-doors-newsletter-success]')).find(function (e) { return newsletterLocation(e.closest('form')) === news.location; });
      if (marker) { remove(NEWS); send('newsletter_signup', { signup_location: news.location, signup_provider: 'shopify', signup_status: 'form_accepted' }); }
      else if (doc.querySelector('[data-doors-newsletter-error]')) remove(NEWS);
    }
  }
  root.addEventListener('klaviyoForms', function (event) {
    var d = event.detail || {}, id = clean(d.formId || d.formID); if (!/^[a-z0-9]{6}$/i.test(id)) return;
    var host = doc.querySelector('.klaviyo-form-' + id);
    if (d.type === 'open') formLocations[id] = 'popup';
    if (d.type === 'embedOpen') formLocations[id] = newsletterLocation(host);
    if (d.type !== 'submit' || formsSeen.has(id) || !Object.prototype.hasOwnProperty.call(d.metaData || {}, 'email')) return;
    formsSeen.add(id);
    var location = (cfg.klaviyo_footer_forms || []).indexOf(id) >= 0 ? 'footer' : formLocations[id] || (host ? newsletterLocation(host) : 'popup');
    send('newsletter_signup', { signup_location: location, signup_provider: 'klaviyo', signup_status: 'form_accepted', form_id: id });
  });
  function catalog() {
    var products = cfg.product ? [cfg.product] : [];
    doc.querySelectorAll('[data-doors-product]').forEach(function (e) { try { products.push(JSON.parse(e.getAttribute('data-doors-product'))); } catch (error) {} });
    return products;
  }
  function locationFor(target) {
    if (target && target.closest('.swym-ui-component,.swym-wishlist-page')) return 'wishlist';
    if (target && target.closest('.pdp-style-with,.recommended-products-section,[data-doors-list-id="style_with"],[data-doors-list-id="you_may_also_like"],.related-products,.recommendations')) return 'recommendations';
    if (common.context.page_type === 'product') return 'pdp';
    if (common.context.page_type === 'search') return 'search';
    if (/wishlist/.test(root.location.pathname)) return 'wishlist';
    return common.context.page_type === 'collection' || common.context.page_type === 'designer' ? 'plp' : common.context.page_type || 'other';
  }
  doc.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-swaction],.swym-button,.wishlist-btn,.swym-delete-btn');
    if (!target) return;
    var card = target.closest('[data-doors-product]'), id = target.getAttribute('data-product-id') || target.getAttribute('data-empi');
    if (!id && card) { try { id = JSON.parse(card.getAttribute('data-doors-product')).id; } catch (error) {} }
    lastWishlistClick = { at: Date.now(), product_id: numericId(id), location: locationFor(target) };
  }, true);
  function wishlistChange(type, event) {
    var d = event && event.detail && event.detail.d; if (!d) return;
    var item = itemFromSwym(d, catalog(), common.catalog_country); if (!item) { trace('wishlist_product_incomplete', {}); return; }
    var last = wishlistChanges.get(item.item_id), now = Date.now();
    if (last && last.type === type || type === 'add_to_wishlist' && wishlistMembership.has(item.item_id) ||
      type === 'remove_from_wishlist' && wishlistMembershipReady && !wishlistMembership.has(item.item_id)) {
      trace('wishlist_no_state_change', { event_name: type }); return;
    }
    wishlistTouched.add(item.item_id);
    if (type === 'add_to_wishlist') wishlistMembership.add(item.item_id); else wishlistMembership.delete(item.item_id);
    wishlistChanges.set(item.item_id, { type: type, at: now });
    var place = lastWishlistClick && now - lastWishlistClick.at < 15000 && (!lastWishlistClick.product_id || lastWishlistClick.product_id === numericId(d.empi)) ? lastWishlistClick.location : locationFor(null);
    if (type === 'add_to_wishlist') send(type, { items: [item], currency: common.currency, value: item.price, interaction_location: place });
    else send(type, { item_id: item.item_id, interaction_location: place });
  }
  function visible(node) { if (doc.visibilityState === 'hidden' || !node) return false; var r = node.getBoundingClientRect(), style = root.getComputedStyle(node); return r.width > 0 && r.height > 0 && style.display !== 'none' && style.visibility !== 'hidden'; }
  function wishlistViews() {
    if (!swym || typeof swym.fetch !== 'function' || !allowed() || doc.visibilityState === 'hidden') return;
    var page = /\/pages\/(swym-wishlist|user-wishlist|wishlist)\/?$/.test(root.location.pathname);
    var surfaces = page ? [doc.body] : Array.from(doc.querySelectorAll('.swym-wishlist-modal-container,.swym-wishlist-page'));
    surfaces.forEach(function (node) {
      if (!node.children.length || !visible(node)) { if (!page) viewNodes.delete(node); return; }
      if (viewNodes.has(node) || fetchingViews.has(node)) return;
      fetchingViews.add(node); var eligible = allowed();
      swym.fetch(function (items) {
        fetchingViews.delete(node); if (!Array.isArray(items) || !visible(node)) return;
        viewNodes.add(node); if (!eligible) return;
        send('view_wishlist', { wishlist_item_count: items.length });
      });
    });
  }
  function swymReady(api) {
    if (swym || !api || !api.evtLayer || typeof api.evtLayer.addEventListener !== 'function') return;
    swym = api;
    api.evtLayer.addEventListener('sw:addedtowishlist', function (event) { wishlistChange('add_to_wishlist', event); });
    api.evtLayer.addEventListener('sw:removedfromwishlist', function (event) { wishlistChange('remove_from_wishlist', event); });
    loadWishlistMembership();
    trace('swym_listeners_ready', {}); wishlistViews();
  }
  function loadWishlistMembership() {
    if (!allowed() || !swym || typeof swym.fetch !== 'function' || wishlistMembershipReady || membershipLoading) return;
    membershipLoading = true;
    swym.fetch(function (items) {
      membershipLoading = false;
      if (!allowed() || !Array.isArray(items)) return;
      items.forEach(function (d) {
        var p = numericId(d.empi), v = numericId(d.epi);
        if (!p || !v) return;
        var id = 'shopify_' + (common.catalog_country || 'US') + '_' + p + '_' + v;
        if (!wishlistTouched.has(id)) wishlistMembership.add(id);
      });
      wishlistMembershipReady = true; trace('swym_membership_ready', { item_count: items.length });
    });
  }
  root.SwymCallbacks = root.SwymCallbacks || []; root.SwymCallbacks.push(swymReady); swymReady(root._swat);
  var observerScheduled = false;
  if (root.MutationObserver && doc.body) new root.MutationObserver(function () {
    if (observerScheduled) return; observerScheduled = true;
    root.setTimeout(function () { observerScheduled = false; wishlistViews(); }, 150);
  }).observe(doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style','aria-hidden'] });
  doc.addEventListener('visitorConsentCollected', function () { if (!allowed()) { queue = []; remove(AUTH); remove(NEWS); } else { completeForms(); loadWishlistMembership(); wishlistViews(); probe(); } });
  doc.addEventListener('visibilitychange', wishlistViews);
  if (root.Shopify && typeof root.Shopify.loadFeatures === 'function') root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { completeForms(); loadWishlistMembership(); wishlistViews(); probe(); });
  completeForms(); probe();
  timer = root.setInterval(function () { swymReady(root._swat); completeForms(); loadWishlistMembership(); wishlistViews(); probe(); if (ready && swym || ++attempts >= 120) root.clearInterval(timer); }, 250);
  trace('initialized', { theme_id: common.theme_id, logged_in: !!cfg.logged_in });
})(typeof window === 'object' ? window : null);
